// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.composition-table-container {
  --table-bg-color: #fff;
  --table-border-color: var(--cui-border-color, #d8dbe0);
  --table-text-color: var(--cui-body-color, #4f5d73);
}
html[data-coreui-theme=dark] .composition-table-container {
  --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);
  --table-border-color: var(--cui-dark-border-subtle, #333);
  --table-text-color: var(--cui-body-color, #fff);
}
.composition-table-container .table {
  width: 100%;
  margin-bottom: 0;
  color: var(--table-text-color);
  border-color: var(--table-border-color) !important;
}
.composition-table-container .table .table-header-cell {
  font-weight: 600;
  border-color: var(--table-border-color) !important;
}
.composition-table-container .table .table-header-cell.sortable-header {
  cursor: pointer;
}
.composition-table-container .table tbody tr:hover {
  background-color: inherit;
  border-color: var(--table-border-color) !important;
  color: var(--table-text-color) !important;
}
.composition-table-container .table tbody tr:hover td {
  color: var(--table-text-color) !important;
}
.composition-table-container .table tbody tr:hover th {
  color: var(--table-text-color) !important;
}
.composition-table-container .table td {
  border-color: var(--table-border-color) !important;
}
.composition-table-container .card {
  background-color: var(--table-bg-color);
  border-color: var(--table-border-color) !important;
}
.composition-table-container .card .card-body {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.composition-table-container .pagination {
  margin-top: 1rem;
}
.composition-table-container .cursor-pointer {
  cursor: pointer;
}
.composition-table-container .cursor-pointer:hover {
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/components/CompositionTable/CompositionTable.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,sDAAA;EACA,kDAAA;AACF;AACE;EACE,oDAAA;EACA,yDAAA;EACA,+CAAA;AACJ;AAEE;EACE,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,kDAAA;AAAJ;AAEI;EACE,gBAAA;EACA,kDAAA;AAAN;AAEM;EACE,eAAA;AAAR;AAII;EACE,yBAAA;EACA,kDAAA;EACA,yCAAA;AAFN;AAIM;EACE,yCAAA;AAFR;AAKM;EACE,yCAAA;AAHR;AAOI;EACE,kDAAA;AALN;AASE;EACE,uCAAA;EACA,kDAAA;AAPJ;AASI;EACE,uCAAA;EACA,8BAAA;AAPN;AAWE;EACE,gBAAA;AATJ;AAYE;EACE,eAAA;AAVJ;AAYI;EACE,YAAA;AAVN","sourcesContent":[".composition-table-container {\n  --table-bg-color: #fff;\n  --table-border-color: var(--cui-border-color, #d8dbe0);\n  --table-text-color: var(--cui-body-color, #4f5d73);\n\n  html[data-coreui-theme=\"dark\"] & {\n    --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);\n    --table-border-color: var(--cui-dark-border-subtle, #333);\n    --table-text-color: var(--cui-body-color, #fff);\n  }\n\n  .table {\n    width: 100%;\n    margin-bottom: 0;\n    color: var(--table-text-color);\n    border-color: var(--table-border-color) !important;\n\n    .table-header-cell {\n      font-weight: 600;\n      border-color: var(--table-border-color) !important;\n\n      &.sortable-header {\n        cursor: pointer;\n      }\n    }\n\n    tbody tr:hover {\n      background-color: inherit;\n      border-color: var(--table-border-color) !important;\n      color: var(--table-text-color) !important;\n      \n      td {\n        color: var(--table-text-color) !important;\n      }\n      \n      th {\n        color: var(--table-text-color) !important;\n      }\n    }\n\n    td {\n      border-color: var(--table-border-color) !important;\n    }\n  }\n\n  .card {\n    background-color: var(--table-bg-color);\n    border-color: var(--table-border-color) !important;\n\n    .card-body {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n    }\n  }\n\n  .pagination {\n    margin-top: 1rem;\n  }\n\n  .cursor-pointer {\n    cursor: pointer;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
